export default "/images/stars.png?0cb68463b5014cecb901069893288cb8";